/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  sizeParams.ts
 */

import { ImageCdnParams } from '../ImageCdnParams'

export type SizeParams = Required<Pick<ImageCdnParams, 'h' | 'w'>> &
  Omit<ImageCdnParams, 'h' | 'w'>

export const toRatio = (width: number, height: number) => height / width

export const sizeParams = (
  width: number,
  ratio: number,
  params?: ImageCdnParams
): SizeParams => {
  return {
    ...params,
    h: width * ratio,
    w: width,
  }
}
